import React, { FunctionComponent, useEffect } from "react";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import Autocomplete from "../../../components/Autocomplete";
import { useBillingPage } from "../BillingContext";

const useStyles = makeStyles(() => ({
  mainContainer: {
    marginTop: 12,
  },
  formControl: {
    marginTop: 26,
  },
}));

export const FilterForm: FunctionComponent<FormRenderProps> = ({
  submitError,
}) => {
  const classes = useStyles();
  const { values } = useFormState();
  const {
    studentNames,
    isLoadingNames,
    studentCountries,
    isLoadingCountries,
    updateFilter,
  } = useBillingPage();

  useEffect(() => {
    updateFilter(values);
  }, [updateFilter, values]);

  return (
    <form>
      {submitError && <Typography color="error">{submitError}</Typography>}
      <div className={classes.mainContainer}>
        <div>
          <Field
            fullWidth
            multiple={false}
            name="student"
            label="Full Name"
            placeholder="Full Name"
            options={studentNames}
            loading={isLoadingNames.toString()}
            disabled={isLoadingNames}
            component={Autocomplete}
          />
        </div>
        <div className={classes.formControl}>
          <Field
            fullWidth
            multiple={true}
            name="countries"
            label="Country"
            placeholder="Country"
            disableCloseOnSelect
            options={studentCountries}
            loading={isLoadingCountries.toString()}
            disabled={isLoadingCountries}
            component={Autocomplete}
          />
        </div>
      </div>
    </form>
  );
};
